import { createContext, useContext, useEffect, useState } from 'react';
import { THEMES, DEFAULT_THEME } from './themes';

const STORAGE_KEY = 'mb-theme-v2';
const ThemeContext = createContext({ theme: DEFAULT_THEME, setTheme: () => {} });

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(
    () => window.localStorage.getItem(STORAGE_KEY) || DEFAULT_THEME
  );

  useEffect(() => {
    const active = THEMES[theme] || THEMES[DEFAULT_THEME];
    const root = document.documentElement;
    Object.entries(active.vars).forEach(([k, v]) => root.style.setProperty(k, v));
    root.setAttribute('data-theme', active.id);
    root.style.colorScheme = active.mode;
    window.localStorage.setItem(STORAGE_KEY, active.id);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeProvider;
